import React, { useEffect, Fragment, useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  APPLICATION_TYPE_COLLECTION_AGENCY, 
  APPLICATION_TYPE_COLLECTOR, 
  APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY, 
  APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT
} from '../app/constants'
import { unlockApplicationAndResetStatus } from '../redux/slice/businessLicenceApplicationSlice';

/*
 * A wrapper is added to always scroll the window to the top. 
 * This is done to set the scroll to top of the page whenever the screen changes from 
 * a very long screen. 
 * 
 * More details : https://stackoverflow.com/questions/36904185/react-router-scroll-to-top-on-every-transition
 */
function ScrollToTop({ history, children }) {
  const viewStack = useMemo(() => [], [])

  const dispatch = useDispatch()

  const checkBLTReviewNavigation = useCallback(() => { 
    const {pathname} = history.location

    if(pathname) { 
      let bltAdminReviewPopNavigationEvent = false

      if(history.action.toLowerCase() === "push") { 
        if (viewStack.length > 0 
          && (pathname.search("/admin/home") !== -1 
              && viewStack[viewStack.length - 1].search("/admin/review") !== -1)) 
        {
          bltAdminReviewPopNavigationEvent = true
        }
  
        viewStack.push(pathname)
      } else if (history.action.toLowerCase() === "pop") { 
        if(viewStack.length > 0 && (viewStack.pop().search("/admin/review") !== -1)) {
          bltAdminReviewPopNavigationEvent = true
        }
      }
  
      if(bltAdminReviewPopNavigationEvent) {
        dispatch(unlockApplicationAndResetStatus())
      }
    }
  }, [history, viewStack, dispatch])

  const setDocumnetTitleFromCurrentPath = useCallback(() => {
  
    const {pathname} = history.location

    if(pathname) { 

      const paths = pathname.split("/").filter(s => s.length )

      if(paths.length > 0) { 
        switch(paths[0]) { 
          case APPLICATION_TYPE_COLLECTION_AGENCY : 
          case APPLICATION_TYPE_COLLECTOR :
            document.title = "Collection Agency"
            break
          case APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY : 
          case APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT :
            document.title = "Debt Management Agency"
            break
          default : 
            document.title = "Business Licence"
            break
        }
      }
    }
  }, [history])

  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
      checkBLTReviewNavigation()
      setDocumnetTitleFromCurrentPath()
    });
    return () => {
      unlisten();
    }
  }, [history, checkBLTReviewNavigation, setDocumnetTitleFromCurrentPath]);

  return <Fragment>{children}</Fragment>;
}

export default withRouter(ScrollToTop);
